import styles from './SeenInHomework.module.css';

export const SeenInHomework = () => <span className={styles.SeenInHomework}>Seen in homework</span>;
